import { render, staticRenderFns } from "./sideBarTop.vue?vue&type=template&id=6efb0e2d&scoped=true&lang=pug&"
import script from "./sideBarTop.vue?vue&type=script&lang=ts&"
export * from "./sideBarTop.vue?vue&type=script&lang=ts&"
import style0 from "./sideBarTop.vue?vue&type=style&index=0&id=6efb0e2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb0e2d",
  null
  
)

export default component.exports